/**
 * Scheduler is responsible for scheduling actions triggered after a given delay.
 * @returns A scheduler.
 */
export const timeoutScheduler = () => {
    return {
        scheduleAction: (action, interval) => {
            setTimeout(action, interval);
        },
    };
};
//# sourceMappingURL=scheduler.js.map